export default __webpack_public_path__ + "KaTeX_Main-BoldItalic.bc8d96e9689171ea65cb379f7967fb4a.ttf";